interface Props {
  name: string;
  x: number;
  y: number;
}

/** Title estilizado que segue o mouse enquanto o cursor está no SQM do jogador. */
export function PlayerTip({ name, x, y }: Props) {
  const left = Math.max(8, Math.min(x, window.innerWidth - 180));
  const top = Math.max(8, Math.min(y, window.innerHeight - 48));
  return (
    <div className="player-tip" role="tooltip" style={{ left, top }}>
      <strong className="player-tip__name">{name}</strong>
    </div>
  );
}
